import CONFIG from "@/api/config";
import useFetchGroup from "@/api/hooks/useFetchGroup";
import usePageData from "@/api/hooks/usePageData";
import clsx from "clsx";
import React, { useEffect, useMemo, useState } from "react";


interface WhyChooseUsProps {
    title: string;
    data?: any;
}

const WhyChooseUs: React.FC<WhyChooseUsProps> = (props) => {
    

 
    return (
        <div>

            <h2 className="light bordered"
                dangerouslySetInnerHTML={{
                    __html: props.title
                }}
            >

            </h2>

            <div className="panel-group accordian-style2" id="accordion2">

                {
                    props.data?.map(
                        (record: any, index: number) => {
                            return (
                                <div
                                    key={"why-choose-us-" + index}
                                    className="panel panel-default">

                                    <div className="panel-heading">
                                        <h4 className="panel-title">
                                            <a data-toggle="collapse" data-parent="#accordion2" href={"#collapse" + index}>
                                                <i className={
                                                    clsx("fa", record.icon)
                                                }></i>
                                                {record.title}
                                                <i className="fa fa-angle-down pull-right"></i>
                                            </a>
                                        </h4>
                                    </div>

                                    <div id={"collapse" + index} className="panel-collapse collapse in">
                                        <div className="panel-body"
                                            dangerouslySetInnerHTML={{
                                                __html: record.content
                                            }}
                                        >
                                        </div>
                                    </div>
                                </div>
                            )
                        }
                    )
                }

            </div>

        </div>
    );
}

export default WhyChooseUs;